// The states the payer profile account manager filter keeps in focus, shared
// by the dropdown (payer_profile_account_manager_controller.js) and the state
// maps (simple_us_state_map_chart_controller_base.js). Null means no filter.

// Lighter than the N/I gray, so filtered-out states read as set aside rather
// than as missing data
export const FILTERED_OUT_COLOR = "#eef0f3";

let focusedStates = null;
const listeners = new Set();

export const getFocusedStates = () => focusedStates;

export const setFocusedStates = states => {
  focusedStates = states ? new Set(states) : null;
  listeners.forEach(listener => listener(focusedStates));
};

// Returns a function that stops listening
export const onFocusedStatesChange = listener => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};
